import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { switchMap } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/loader.service';
import { PaymentReceiptService } from 'src/app/services/payment-receipt.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-success-divisional-transaction',
  templateUrl: './success-divisional-transaction.component.html',
  styleUrls: ['./success-divisional-transaction.component.css']
})
export class SuccessDivisionalTransactionComponent implements OnInit {

  isCompleted: boolean = false;
  check: any;
  id: number; // Идентификатор транзакции
  // глобальные параметры валюты приложения
  globalLocation = environment.globalLocation;
  globalCurrencyCode = environment.globalCurrencyCode;

  mailForm = this.fb.group({
    email: [null, [Validators.required, Validators.email]]
  });

  constructor(private route: ActivatedRoute,
    private translate: TranslateService,
    private fb: FormBuilder,
    public snackBar: MatSnackBar,
    private transactionSrv: TransactionService,) { }

  ngOnInit(): void {
    this.load();
  }

  // convenience getter for easy access to form fields
  get f() { return this.mailForm.controls; }

  load() {
    this.route.paramMap.pipe(
      switchMap(params => params.getAll('id'))
    )
      .subscribe(data => this.id = +data);
    this.getCheck();
  }

  getCheck() {
    this.isCompleted = false;

    this.transactionSrv.getDivisionalTransaction(this.id.toString()).subscribe(
      data => {
        console.log(data);
        this.check = data;
      },
      error => {
        let message = this.translate.instant('an-error-occurred-while-processing');
        this.openSnackBar(message, 'x');
      }
    ).add(() => { this.isCompleted = true });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }

}
